import { Modal } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { PersonList } from "../components/PersonList";
import { fetchDoctors } from "../features/doctor/doctorsSlice";
import { Person } from "../model/person";
import { RouteNames } from "../routes";
import { useTranslate } from "../i18n";
import { formatPhone } from "../utils/formatPhone";
import { getErrorMessage } from "../utils/getErrorMessage";

export const DoctorsPage = () => {
    const dispatch = useAppDispatch();
    const t = useTranslate();
    const doctors = useAppSelector((state) => state.doctors.doctors);
    const status = useAppSelector((state) => state.doctors.status);
    const error = useAppSelector((state) => state.doctors.error);
    const countries = useAppSelector((state) => state.country.countries);

    const navigate = useNavigate();
    const params = useParams();

    const isEditPage = params.doctorId !== undefined;
    const onEditDoctor = (id?: String) => {
        navigate(`/${RouteNames.doctors}/${id}`);
    }

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchDoctors());
        }

    });

    const [isErrorDismissed, setIsErrorDismissed] = useState(false);

    const reloadDoctors = () => {
        setIsErrorDismissed(false);
        dispatch(fetchDoctors());
    }

    const onSearch = (query: string) => {
        dispatch(fetchDoctors({ q: query }));
    }

    const handleOk = () => {
        setIsErrorDismissed(true);
        dispatch(fetchDoctors());
    }

    const handleCancel = () => {
        setIsErrorDismissed(true);
    }

    if (isEditPage) {
        return <Outlet />;
    }

    const failed = status === "error" || status === "auth-error";
    const errorMessage = getErrorMessage(error, t);

    //todo implement server side paging and sorting
    return (<>
        <PersonList
            persons={doctors?.map<Person>((doctor) => {
                return {
                    id: doctor.id ?? "",
                    firstName: doctor.firstName ?? "",
                    lastName: doctor.lastName ?? "",
                    phoneNumber: formatPhone(doctor.userAccount?.mobileNumber, countries),
                    email: doctor.userAccount?.emailAddress ?? ""
                };
            }) ?? []}
            title={t("nav.doctors")}
            loading={status === "loading" || status === "idle"}
            onEditPerson={onEditDoctor}
            onReload={reloadDoctors}
            onSearch={onSearch}
        />
        <Modal
            title={errorMessage.title}
            visible={failed && !isErrorDismissed}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={t("common.retry")}
        >
            <p>{errorMessage.details}</p>
        </Modal>
    </>);
}
